import { store } from '../app/store';
export function getCurrentGroupId() {
    return store.getState().authSlicer.user.currentGroupId;
}
export function getManagerId() {
    return store.getState().authSlicer.user.managerId;
}
